(function() {
    angular
        .module("app")
        .controller("ShowWZDxPasswordModalController", ShowWZDxPasswordModalController)

    ShowWZDxPasswordModalController.$inject = [
        "$state",
        "$scope",
        "$uibModalInstance",
        "password"
    ]

    function ShowWZDxPasswordModalController(
        $state,
        $scope,
        $uibModalInstance,
        password
    ){
        "use strict"

        $scope.password = password

        $scope.close = function() {
            $uibModalInstance.dismiss("cancel")
        }
    }
})()
